import { render, staticRenderFns } from "./HelpDeskStatistics.vue?vue&type=template&id=89bdbdf4"
import script from "./HelpDeskStatistics.vue?vue&type=script&lang=js"
export * from "./HelpDeskStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports